import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  CircularProgress,
  Box,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse";
import TopNavBar from "../components/TopNavBar";
import { getDevices } from "../api/devices";
import LaunchIcon from "@mui/icons-material/Launch";
import FileUpload from "../components/FileUpload";
import AttachmentsList from "../components/AttachmentsList";

export default function ServicePage() {
  const username = sessionStorage.getItem("username");
  const { jobId } = useParams();

  return (
    <>
      <TopNavBar
        title="device - RC Service Tool"
        username={username}
        heading={"Services"}
      />
      <Container sx={{ mt: 4, width: "60%", maxWidth: "60%", mx: "auto" }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Create New Task
        </Typography>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Search Tasks
        </Typography>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Navigate to edit task page
        </Typography>
        <Box>
          <Typography variant="h6">Attachments</Typography>
          <FileUpload
            jobId={jobId}
            //taskId={taskId} // Optional
            onUploadComplete={() => {
              // Refresh attachments list
            }}
          />
          <AttachmentsList jobId={jobId} />
        </Box>
      </Container>
    </>
  );
}
